import { Grid } from "@material-ui/core";

const totalValueGetter = (items, key) => {
  return items.reduce((acc, item) => {
    return acc + item[key];
  }, 0);
};

const convertListArrayIntoString = (items, key) => {
  const list = items.map((item) => item[key]).filter(Boolean);
  return list.length > 0 ? [...new Set(list)].join(", ") : "-";
};

const PropertyRow = ({ label, value }) => (
  <>
    <Grid item xs={4}>
      {label}
    </Grid>
    <Grid item xs={2}>
      {value}
    </Grid>
  </>
);

const StopProperties = ({ selectedStops }) => (
  <Grid container spacing={16}>
    <PropertyRow
      label="Pros"
      value={totalValueGetter(selectedStops, "bills")}
    />
    <PropertyRow
      label="HU"
      value={totalValueGetter(selectedStops, "totalHu")}
    />
    <PropertyRow
      label="Weight"
      value={totalValueGetter(selectedStops, "totalWeight")}
    />
    <PropertyRow
      label="Priority"
      value={convertListArrayIntoString(selectedStops, "priority")}
    />
  </Grid>
);

export default StopProperties;
